// extracted by mini-css-extract-plugin
export var current = "AnchorMenu-module--current--67239";
export var fadeInAnimation = "AnchorMenu-module--fadeInAnimation--3b5f6";
export var layout = "AnchorMenu-module--layout--e8809";
export var link = "AnchorMenu-module--link--7cc85";
export var visible = "AnchorMenu-module--visible--66aa6";
export var wrapper = "AnchorMenu-module--wrapper--5d1f9";